import { Stack } from '@mui/material';
import Locations from './Locations';
import RecipeEditors from './RecipeEditors';

export default function LocationsAndRecipeEditors(): JSX.Element {
  return (
    <Stack direction='column' gap={2} width='100%' pt={2}>
      <Locations />
      <RecipeEditors />
    </Stack>
  );
}
